import { defined } from '@unifocus/js-utils';

export const convertSize = (size?: string | number, defaultSize?: string) => {
   if (!defined(size)) {
      return defaultSize;
   }

   if (typeof size === 'string' || size === 0) {
      return size;
   }

   return size + 'px';
};
